module.exports = __webpack_public_path__ + "static/media/icon_cloud_upload.c63d6511.svg";